import logo from './logo.svg';
import './App.css';
import FloorPlanExperience from './Components/FloorPlanExperience';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {



  return (
    <div className="App">
    <FloorPlanExperience/>
    </div>
  );
}

export default App;
